// @lumi/app-kit shared i18n vocabulary (ADR 0026 §7) — locale pl.
// Byte-identical common.*/errors.* used across >=3 apps + owned by app-kit components.
// Apps merge appKitMessages under their own catalog; the no-shadow check forbids an
// app from redefining these keys. Generated from the per-app catalogs.
export default {
  // The sidebar's account menu + history buttons (suite design foundation, spec §4):
  // byte-identical across every chrome, so owned here rather than by nine app catalogs.
  accountMenu: {
    profile: 'Mój profil',
    settings: 'Ustawienia',
    theme: 'Wygląd',
    themeLight: 'Jasny',
    themeDark: 'Ciemny',
    support: 'Pomoc',
    back: 'Wstecz',
    forward: 'Dalej',
    collapseSidebar: 'Zwiń pasek boczny',
    expandSidebar: 'Rozwiń pasek boczny',
    // The account row of a phone-only account (issue 698): no name, no address.
    signedIn: 'Zalogowano',
  },
  // A sidebar entry another of the viewer's own roles opens (#1028): the
  // greyed entry's hint, its switch dialog, and the role list joiner.
  roleLock: {
    hint: 'Tylko w roli {roles}. Zmiana roli: na dole po lewej, konto → Rola.',
    body: 'Ten obszar jest dostępny w roli {roles}. Aktywna rola: {active}.',
    action: 'Otwórz jako {role}',
    where: 'Rolę można zmienić w każdej chwili: na dole po lewej, konto → Rola.',
    listOr: '{list} lub {last}',
  },
  common: {
    // Every DateField's calendar and typing hint (issue 823; People's own until then).
    datePicker: {
      open: 'Otwórz kalendarz',
      previousMonth: 'Poprzedni miesiąc',
      nextMonth: 'Następny miesiąc',
      month: 'Miesiąc',
      year: 'Rok',
      clear: 'Wyczyść datę',
      dayToken: 'DD',
      monthToken: 'MM',
      yearToken: 'RRRR',
    },
    deactivate: 'Dezaktywuj',
    revoke: 'Cofnij',
    remove: 'Usuń',
    actions: 'Akcje',
    calendar: 'Kalendarz',
    cancel: 'Anuluj',
    close: 'Zamknij',
    confirmTitle: 'Potwierdź',
    contactSupport: 'Skontaktuj się z pomocą',
    copyLink: 'Kopiuj link',
    edit: 'Edytuj',
    language: 'Język',
    linkCopied: 'Link skopiowany',
    linkCopyFailed: 'Nie udało się skopiować linku',
    moduleListHeading: 'Państwa moduły',
    moduleTeaserAction: 'Dodaj w rozliczeniach',
    moduleTeaserHeading: 'Również w lumi',
    moduleTeaserNote: 'Właściciel obszaru roboczego, administratorzy i Billing Managerowie mogą dodać te moduły.',
    moduleTeaserTag: 'Poza planem',
    no: 'Nie',
    nothingHere: 'Jeszcze nic tu nie ma',
    ok: 'OK',
    refresh: 'Odśwież',
    retry: 'Spróbuj ponownie',
    role: 'Rola',
    save: 'Zapisz',
    search: 'Szukaj',
    switchModule: 'Przełącz moduł',
    tabsNext: 'Pokaż kolejne karty',
    tabsPrevious: 'Pokaż poprzednie karty',
    understood: 'Rozumiem',
    userDeactivated: '{name} (konto nieaktywne)',
    yes: 'Tak',
  },
  errors: {
    // ADR 0036 code-first branch (errorKeyFor): a backend `code` wins over the
    // status. `invalid_credentials` is what every login door answers a bad
    // sign-in with — a bare 401 would otherwise fall through to
    // `errors.unauthorized`, telling someone who mistyped their password that
    // their session expired (issue 364, F10). It never lets a caller tell an
    // unknown account apart from a mistyped password — the two answer
    // identically — so the copy names both fields.
    // `MASTER_INVITE_REJECTED` is people-api's fallback when the identity
    // service refuses an invitation payload without a code of its own (issue
    // 364, decisions round 1): without an entry here it degrades to the
    // status-derived message, which says nothing about what to look at. Its
    // sibling `MASTER_TENANT_NOT_FOUND` stays local to PersonDetailView on
    // purpose — that one names a next step specific to that screen.
    codes: {
      invalid_credentials: 'Logowanie nie powiodło się. Proszę sprawdzić adres e-mail i hasło.',
      MASTER_INVITE_REJECTED: 'Zaproszenie zostało odrzucone, ponieważ dane osoby nie mogły zostać zaakceptowane. Prosimy sprawdzić adres e-mail oraz imię i nazwisko w danych osoby i spróbować ponownie.',
      PERSON_EMAIL_INVALID: 'Ta osoba nie ma prawidłowego adresu e-mail, dlatego nie można zaprosić do logowania. Prosimy najpierw poprawić adres w danych osoby.',
      PERSON_PHONE_INVALID: 'Ten numer telefonu komórkowego jest nieprawidłowy. Wpisz go w formacie międzynarodowym, z + i numerem kierunkowym kraju, np. +48 512 345 678.',
      PERSON_ACCESS_PHONE_TAKEN: 'Inna osoba ma już login z tym numerem telefonu albo właśnie go otrzymuje. Jeden numer, jedna osoba.',
      PHONE_ACCESS_UNAVAILABLE: 'Dostęp przez numer telefonu nie jest tu dostępny — dla tej przestrzeni roboczej lub dla kraju tego numeru. Zamiast tego użyj adresu e-mail.',
      SUITE_ROLE_NEEDS_EMAIL: 'Ta osoba loguje się numerem telefonu komórkowego i nie ma adresu e-mail. Role w pakiecie otrzymują wiadomości prawne, rozliczeniowe i dotyczące zgód, dlatego wymagają adresu.',
      OWNER_NEEDS_EMAIL: 'Ta osoba loguje się numerem telefonu komórkowego i nie ma adresu e-mail. Właściciel otrzymuje wiadomości prawne i umowne, dlatego własność wymaga adresu.',
      RECORD_CHANGED: 'Ktoś inny zmienił ten rekord, gdy go edytowałeś. Wczytaj go ponownie – Twoje dane zostaną zachowane jako szkic.',
    },
    appUpdatedBody: 'Ta strona nie została w pełni załadowana, ponieważ aplikacja została zaktualizowana. Proszę odświeżyć, aby kontynuować.',
    appUpdatedTitle: 'Dostępna jest nowa wersja',
    conflict: 'Ta akcja jest w konflikcie z aktualnym stanem. Proszę odświeżyć i spróbować ponownie.',
    contactSupport: 'Skontaktuj się z pomocą',
    exhausted: 'To naprawdę wygląda na zepsute. Przepraszamy. Proszę skontaktować się z pomocą techniczną.',
    failedTitle: 'Operacja nie powiodła się',
    forbidden: 'Nie mają Państwo uprawnień do tej akcji.',
    loadFailedTitle: 'Nie udało się wczytać',
    network: 'Brak połączenia z serwerem. Proszę sprawdzić połączenie internetowe.',
    notFound: 'Nie znaleziono żądanego elementu.',
    rateLimited: 'Zbyt wiele żądań. Proszę poczekać chwilę i spróbować ponownie.',
    recordChangedReload: 'Ktoś inny zapisał ten rekord po tym, jak go otworzyłeś, dlatego Twoja zmiana nie została zastosowana. Wczytaj ponownie, aby zobaczyć aktualną wersję – Twoje dane zostaną zachowane i można je przywrócić.',
    refreshFailedTitle: 'Te dane mogą być nieaktualne',
    server: 'Wystąpił błąd serwera. Proszę spróbować ponownie później.',
    timeout: 'Serwer nie odpowiedział na czas. Proszę spróbować ponownie za chwilę.',
    unauthorized: 'Państwa sesja wygasła. Proszę zalogować się ponownie.',
    unexpected: 'Podczas wyświetlania wystąpił błąd. Proszę spróbować ponownie.',
    validation: 'Proszę sprawdzić wprowadzone dane.',
  },
  notReady: {
    title: 'To nie jest jeszcze gotowe',
    body: 'Obszar roboczy jest wciąż przygotowywany. Za 5 sekund nastąpi powrót do przestrzeni roboczej.',
  },
  // The workspace this app was opened on does not exist, or can no longer be
  // reached (issue 364, F57). ONE message for BOTH causes on purpose: ats-api
  // answers a suspended tenant and an unknown slug identically, and splitting
  // the copy would confirm which workspaces exist. `body` therefore names no
  // cause, and nothing on the page names a workspace, a slug or a person.
  tenantUnavailable: {
    title: 'Ta przestrzeń robocza jest niedostępna',
    body: 'Ta przestrzeń robocza nie istnieje lub w tej chwili jest niedostępna — prosimy sprawdzić otwarty adres.',
    accountLead: 'Własne dane i faktury pozostają dostępne na koncie lumi.',
    accountCta: 'Przejdź do konta lumi',
    supportLead: 'Jeśli to pomyłka, prosimy o kontakt — wyjaśnimy to wspólnie.',
    // The signed-in person's own membership is gone (issue 669): a revoked demo guest,
    // or a demo that ended under an open tab.
    ended: {
      title: 'Brak dostępu do tej przestrzeni roboczej',
      body: 'Jest Pan/Pani zalogowany/a, ale nie jest (lub już nie jest) Pan/Pani członkiem tej przestrzeni roboczej. Jeśli był(a) Pan/Pani gościem w demo, demo zostało zakończone albo zaproszenie zostało wycofane.',
      accountLead: 'To nie dotyczy Pana/Pani własnego konta lumi.',
    },
  },
  billing: {
    banner: {
      suspendedTitle: 'Przestrzeń zablokowana',
      suspendedMessage: 'Ta przestrzeń robocza jest zawieszona. Prosimy o kontakt z nami, aby przywrócić dostęp.',
      lockedBody: 'Ta przestrzeń robocza została zablokowana z powodu nierozwiązanego problemu z płatnościami. Dostęp do wszystkich modułów jest obecnie wstrzymany.',
      lockedSupportLead: 'Prosimy skontaktować się z naszym zespołem pomocy technicznej, aby przywrócić dostęp:',
      lockedSupportCta: 'Skontaktuj się z pomocą techniczną',
      lockoutOn: 'W przeciwnym razie zostanie zablokowana {date}.',
      fixCardTitle: 'Prosimy zaktualizować kartę',
      fixCardBody: 'Ostatnia płatność została odrzucona, ponieważ karta nie została zaakceptowana.',
      fixCardCta: 'Zaktualizuj kartę',
      softDeclineTitle: 'Prosimy zapewnić płatność',
      softDeclineBody: 'Nie udało nam się pobrać ostatniej płatności i spróbujemy ponownie automatycznie. Prosimy upewnić się, że metoda płatności ma wystarczające środki.',
      softDeclineCta: 'Sprawdź metodę płatności',
      scaTitle: 'Prosimy potwierdzić płatność',
      scaBody: 'Bank musi potwierdzić tę płatność, zanim będziemy mogli ją pobrać.',
      scaCta: 'Potwierdź płatność',
      recoveryError: 'Nie udało się teraz rozpocząć płatności. Proszę spróbować ponownie za chwilę.',
      chargebackTitle: 'Prosimy uregulować cofniętą płatność',
      chargebackBody: 'Bank cofnął płatność, więc jest ona ponownie należna. Prosimy dodać metodę płatności, aby ją uregulować.',
      chargebackCta: 'Dodaj metodę płatności',
      trialTitle: 'Prosimy dodać metodę płatności',
      trialBody: 'Okres próbny dobiegł końca. Prosimy dodać metodę płatności, aby ta przestrzeń robocza pozostała aktywna.',
      trialCta: 'Dodaj metodę płatności',
      reviewTitle: 'Prosimy sprawdzić płatności',
      reviewBody: 'Ta przestrzeń robocza wymaga działania w zakresie płatności, aby pozostać aktywna.',
      reviewCta: 'Zarządzaj płatnościami',
      contactTitle: 'Prosimy skontaktować się z administratorem',
      contactBody: 'Problem z płatnościami wymaga uwagi, aby ta przestrzeń robocza pozostała aktywna.',
    },
  },
  legalNoticeBanner: {
    title: 'Informacje prawne wymagają uwagi',
    employeeBody: 'Zaproszenia są wstrzymane, dopóki informacja o ochronie danych dla pracowników nie będzie kompletna.',
    candidateBody: 'Portal kariery jest offline, dopóki informacje dla kandydatów nie będą kompletne.',
    imprintBody: 'Portal kariery jest offline, dopóki nie zostanie zapisana nota prawna.',
    candidateImprintBody: 'Portal kariery jest offline, dopóki informacje dla kandydatów nie będą kompletne i nie zostanie zapisana nota prawna.',
    cta: 'Otwórz Informacje prawne',
  },
  // The one "needs you" strip (issue 713): the list label, the hide control and the
  // per-item sentences. A lone legal item reuses legalNoticeBanner.* word for word.
  needsYou: {
    label: 'Wymaga jeszcze Państwa uwagi:',
    hide: 'Ukryj',
    timeRules: {
      link: 'Zasady czasu pracy',
      cta: 'Sprawdź',
      body: 'Zasady czasu pracy nie zostały jeszcze sprawdzone. lumi liczy według ustawowych zasad domyślnych i jedynie ostrzega, dopóki ktoś nie potwierdzi, że pasują do Państwa firmy.',
    },
    legal: { link: 'Uzupełnij informacje prawne' },
    billing: {
      link: 'Uzupełnij rozliczenia',
      cta: 'Otwórz rozliczenia',
      bodyBoth: 'Proszę uzupełnić dane do faktury i dodać metodę płatności, aby przestrzeń robocza działała bez przerw.',
      bodyInvoiceDetails: 'Proszę uzupełnić dane do faktury, aby faktury były wystawiane poprawnie.',
      bodyPaymentMethod: 'Proszę dodać metodę płatności, aby przestrzeń robocza działała bez przerw.',
    },
  },
  // Consented temporary support access (ADR 0041): the marker every module
  // chrome shows beside the tenant name while a supporter is inside a grant.
  supportAccess: {
    label: 'Dostęp wsparcia',
    until: 'Tymczasowy dostęp wsparcia do {until} — wszystko, co tu robisz, jest zapisywane w dzienniku audytu tego tenanta.',
  },
  // Idle session timeout (issue 265). Owned by app-kit's IdleLogoutGuard, except
  // idleSignedOut — the login pages (workspace, system-admin) render that after
  // the bounce, and it is the same suite-wide policy statement, so it stays in one
  // place rather than drifting between the two login surfaces.
  session: {
    idleTitle: 'Jesteś tam jeszcze?',
    idleBody: 'Od dłuższej chwili nic nie robisz. Dla Twojego bezpieczeństwa wylogujemy Cię automatycznie.',
    idleStay: 'Pozostań zalogowany',
    idleSignedOut: 'Nastąpiło wylogowanie po {minutes} minutach bezczynności. Zaloguj się ponownie.',
  },
  // Browser form drafts (owner-stamped, 7 days, typed values only — app-kit
  // utils/formDraftStorage.ts). Owned by app-kit's DraftBanner and by the
  // sign-out warning every module chrome shows, so the wording lives here instead
  // of drifting across five app catalogs.
  formDrafts: {
    bannerTitle: 'Niezapisana wersja robocza',
    bannerSavedAt: 'Zapisano na tym urządzeniu: {when}',
    bannerRecordChanged: 'Rekord zmienił się od czasu zapisania tego szkicu. Przywrócenie przywraca tylko pola zmienione przez Ciebie.',
    restore: 'Przywróć',
    discard: 'Odrzuć',
    closeTitle: 'Odrzucić dane wprowadzone w „{form}”?',
    closeBody: 'Niezapisane dane zostaną utracone.',
    closeConfirm: 'Odrzuć',
    closeCancel: 'Kontynuuj edycję',
    recordChangedTitle: 'Zmienione przez kogoś innego',
    reload: 'Wczytaj ponownie',
    forms: {
      'apprentice': {
        planStation: 'Etap planu szkolenia',
        skillCatalogue: 'Katalog umiejętności',
        trainingData: 'Dane nauki zawodu',
      },
      'ats': {
        workflowEditor: 'Edytor przepływu pracy',
      },
      'backoffice': {
        applicationForm: 'Aplikacja',
        createApplication: 'Nowa aplikacja',
        customField: 'Pole niestandardowe',
        customFields: 'Pola niestandardowe',
        emailSettings: 'Ustawienia poczty e-mail',
        jobAd: 'Ogłoszenie o pracę',
        jobAdTemplate: 'Szablon ogłoszenia o pracę',
        jobEdit: 'Stanowisko',
        portalSettings: 'Ustawienia portalu kariery',
        ravenBatchPublish: 'Zbiorcza publikacja ofert pracy',
        ravenPublish: 'Publikacja oferty pracy',
        role: 'Rola',
        suggestion: 'Sugestia',
        supportTicket: 'Zgłoszenie wsparcia',
        supportTicketReply: 'Odpowiedź na zgłoszenie wsparcia',
        talentEdit: 'Profil talentu',
        workflowAction: 'Akcja przepływu pracy',
        workflowCondition: 'Warunek przepływu pracy',
        workflowGuard: 'Strażnik przepływu pracy',
        workflowState: 'Stan przepływu pracy',
        workflowTransition: 'Przejście przepływu pracy',
      },
      'people': {
        bankAccount: 'Rachunek bankowy',
        companyProfile: 'Profil firmy',
        employmentContract: 'Umowa o pracę',
        myProfile: 'Mój profil',
        onboardingTemplate: 'Szablon onboardingu',
        oneTimePayment: 'Jednorazowa wypłata',
        orgUnit: 'Jednostka organizacyjna',
        person: 'Osoba',
        taxProfile: 'Profil podatkowy',
        wageAssignment: 'Zajęcie wynagrodzenia',
      },
      'system-admin': {
        fileQuota: 'Limit plików',
        skillDetail: 'Szczegóły umiejętności',
        suggestionNotes: 'Notatki do sugestii',
      },
      'time': {
        blueprint: 'Model czasu pracy',
        leaveRequest: 'Wniosek urlopowy',
        leaveType: 'Typ nieobecności',
        orgGroup: 'Grupa organizacyjna',
        project: 'Projekt',
        role: 'Rola',
        userProfile: 'Profil użytkownika',
        weekGrid: 'Siatka tygodnia',
        workTimeModel: 'Model czasu pracy',
      },
      'user': {
        ssoSettings: 'Ustawienia SSO',
      },
      'workspace': {
        billingProfile: 'Profil rozliczeniowy',
        wizardGeneral: 'Kreator konfiguracji',
      },
    },
  },
  // Suite-wide legal footer (issue 221): the § 5 DDG imprint and the privacy
  // notice of the Lumi entity live once on the marketing site, and every app
  // links to them through the shared LegalLinksFooter. The wording is
  // byte-identical everywhere, so it belongs to app-kit rather than to any app.
  legal: {
    imprint: 'Nota prawna',
    privacy: 'Prywatność',
    terms: 'Regulamin',
    label: 'Informacje prawne',
    employeeNotice: 'Prywatność w {company}',
  },
  dataImport: {
    title: 'Import danych',
    intro: 'Zaimportuj istniejące dane ze starego systemu: prześlij plik, sprawdź mapowanie pól, obejrzyj próbny przebieg i dopiero wtedy zatwierdź.',
    backToList: 'Wróć do przeglądu',
    sourceSystem: 'System źródłowy',
    cancelled: 'Ten import został anulowany.',
    steps: {
      upload: 'Przesyłanie',
      analysis: 'Analiza',
      mapping: 'Mapowanie',
      dryRun: 'Próbny przebieg',
      commit: 'Zatwierdzenie',
    },
    status: {
      uploaded: 'Przesłano',
      analyzing: 'Analizowanie',
      mapping_ready: 'Sprawdź mapowanie',
      dry_running: 'Trwa próbny przebieg',
      dry_run_ready: 'Próbny przebieg gotowy',
      committing: 'Zatwierdzanie',
      completed: 'Zakończono',
      failed: 'Niepowodzenie',
      cancelled: 'Anulowano',
    },
    formats: {
      csv: 'CSV',
      xlsx: 'Excel',
      json: 'JSON',
      sql_dump: 'Zrzut SQL',
      hropen: 'HR Open JSON',
    },
    transforms: {
      none: 'Bezpośrednio',
      date: 'Data',
      number: 'Liczba',
      boolean: 'Tak/Nie',
      enum_map: 'Mapowanie wartości',
      split_name: 'Podziel nazwisko',
      concat: 'Połącz',
      const: 'Stała',
      skip: 'Pomiń',
    },
    upload: {
      sourceSystem: 'Nazwa systemu źródłowego',
      sourceSystemHint: 'Zapisywana jako referencja, dzięki czemu ponowny import tego samego pliku aktualizuje rekordy zamiast je duplikować.',
      sourceSystemPlaceholder: 'np. stary_system_hr',
      sourceSystemFirst: 'Najpierw podaj nazwę systemu źródłowego.',
      dropHint: 'Przeciągnij plik tutaj lub wybierz',
      formats: 'CSV, Excel (XLSX), JSON lub zrzut SQL — maks. 50 MB',
      browse: 'Wybierz plik',
      uploading: 'Przesyłanie …',
    },
    running: {
      uploaded: 'Rozpoczynanie analizy …',
      analyzing: 'Analizowanie pliku …',
      dry_running: 'Trwa próbny przebieg …',
      committing: 'Zapisywanie danych …',
      hint: 'Duże pliki mogą potrwać kilka minut. Strona odświeża się automatycznie.',
    },
    failed: {
      title: 'Import nie powiódł się',
    },
    mapping: {
      hint: 'Sprawdź zaproponowane mapowanie: cel dla każdej tabeli i pole dla każdej kolumny. Wyróżnione wiersze to niepewne propozycje.',
      targetEntity: 'Cel',
      skipTable: 'Nie importuj',
      skippedTable: 'Ta tabela nie zostanie zaimportowana.',
      ignoreColumn: 'Pomiń',
      sourceColumn: 'Kolumna',
      sample: 'Przykładowe wartości',
      targetField: 'Pole docelowe',
      transform: 'Transformacja',
      preview: 'Podgląd',
      rowCount: '{count} wierszy',
      patternHint: 'Wzorzec daty, np. DD.MM.YYYY',
      multiTargetHint: 'Cel {index} z {total} — ten sam plik zasila kilka celów',
      valueMap: 'Przypisz wartości',
      valueMapHint: 'Przypisz wartości źródłowe do wartości dozwolonych w systemie. Nieprzypisane wartości powodują błąd w każdym wierszu podczas próbnego przebiegu. Na podstawie maks. 20 różnych przykładowych wartości kolumny.',
      valueMapUnmapped: '— nieprzypisane —',
      addColumnRow: 'Przypisz kolumnę ponownie',
      customFieldBadge: 'Pole niestandardowe',
      createCustomField: 'Utwórz nowe pole niestandardowe…',
      confirm: 'Zatwierdź mapowanie i uruchom próbny przebieg',
    },
    report: {
      dryRunHint: 'Próbny przebieg — nic jeszcze nie zapisano. Sprawdź liczby i błędy przed zatwierdzeniem.',
      completedHint: 'Import zakończony. Dane zostały zapisane.',
      created: 'Utworzone',
      updated: 'Zaktualizowane',
      skipped: 'Pominięte',
      errors: 'Błędy',
      errorList: '{count} błędów',
      downloadErrors: 'Pobierz wszystkie błędy',
      row: 'Wiersz',
      errorMessage: 'Komunikat',
      backToMapping: 'Wróć do mapowania',
      commit: 'Zatwierdź dane',
      commitConfirmTitle: 'Zatwierdzić dane?',
      commitConfirmBody: 'Import zapisze teraz dane w tym module. Nowe rekordy zostaną utworzone, istniejące zaktualizowane. Nie można tego automatycznie cofnąć.',
      commitStarted: 'Zatwierdzanie rozpoczęte – dane są właśnie zapisywane.',
    },
    // An import report's error row, worded from the facts the module sent (rowErrorText.ts).
    rowErrors: {
      required: 'Pole {field} jest puste, a każdy wiersz wymaga wartości.',
      unknownField: 'Pola {field} nie można tu importować.',
      invalidEnum: '„{value}” nie jest dozwoloną wartością pola {field}. Dozwolone wartości: {allowed}. Proszę przypisać wartość w kroku mapowania, w sekcji „Przypisz wartości”.',
      unresolved: {
        person: 'Nie znaleziono osoby o wartości „{value}” w polu: {keys}.',
        supervisor: 'Nie znaleziono przełożonego o wartości „{value}” w polu: {keys}.',
        functionalSupervisor: 'Nie znaleziono przełożonego merytorycznego o wartości „{value}” w polu: {keys}.',
        orgUnit: 'Nie znaleziono jednostki org. o wartości „{value}” w polu: {keys}.',
        parentOrgUnit: 'Nie znaleziono nadrzędnej jednostki org. o wartości „{value}” w polu: {keys}.',
      },
      supervisorRequired: 'Nie znaleziono przełożonego o wartości „{value}” w polu: {keys}, a ta osoba nie ma jeszcze żadnego. Każda aktywna osoba potrzebuje przełożonego: proszę najpierw zaimportować przełożonego lub wskazać istniejącego.',
      unknownEntity: 'Tego rodzaju danych nie można tu importować.',
      emailLinked: 'Ta osoba loguje się do lumi tym adresem e-mail, więc import nie może go zmienić. Proszę wpisać w pliku jej obecny adres lub nie importować kolumny e-mail.',
      supervisorMissing: 'Każda aktywna osoba potrzebuje przełożonego, a ta osoba go nie ma. Proszę wskazać przełożonego w pliku lub najpierw go utworzyć.',
      transformFailed: 'Nie udało się przekształcić wartości „{value}” w kolumnie {field}. Proszę sprawdzić format w sekcji „Transformacja” w kroku mapowania.',
      transformFailedNoValue: 'Nie udało się przekształcić wartości w kolumnie {field}. Proszę sprawdzić format w sekcji „Transformacja” w kroku mapowania.',
      unknown: 'Ten wiersz nie został zaimportowany. Szczegóły znajdują się w pliku błędów.',
      ambiguous: {
        collision: '{ref}: „{value}” pasuje do dwóch różnych rekordów — do jednego jako zewnętrzny identyfikator, do innego jako {other}. Import nie zgaduje: proszę ujednoznacznić odwołanie w pliku.',
        otherSystem: '{ref}: „{value}” nie jest zewnętrznym identyfikatorem z tego systemu źródłowego, lecz z „{system}” — i jednocześnie pasuje do rekordu jako {other}. Import nie zgaduje: proszę importować z systemem źródłowym „{system}”, jeśli chodzi o ten sam rekord, lub ujednoznacznić odwołanie.',
        holderHasExternalId: '{ref}: „{value}” pasuje tylko jako {other} — a ten rekord ma już w tym systemie źródłowym zewnętrzny identyfikator „{otherId}”. Import nie zgaduje: proszę użyć „{otherId}”, jeśli chodzi o ten rekord.',
      },
      refs: {
        person: 'Osoba',
        supervisor: 'Przełożony',
        functionalSupervisor: 'Przełożony merytoryczny',
        orgUnit: 'Jednostka org.',
        parentOrgUnit: 'Nadrzędna jednostka org.',
      },
      supervisorInactive: {
        supervisor: 'Wskazany przełożony nie jest już aktywny i dlatego nie może nikim kierować.',
        functional: 'Wskazany przełożony merytoryczny nie jest już aktywny i dlatego nie może nikim kierować.',
      },
      supervisorUnconfirmed: {
        supervisor: 'Wskazany przełożony nie został jeszcze potwierdzony przez dział HR i dlatego nie może nikim kierować. Proszę najpierw potwierdzić go w People.',
        functional: 'Wskazany przełożony merytoryczny nie został jeszcze potwierdzony przez dział HR i dlatego nie może nikim kierować. Proszę najpierw potwierdzić go w People.',
      },
      datesInverted: 'Data w polu {end} jest wcześniejsza niż w polu {start}.',
      agreementCodeInvalid: 'Pole {field} dopuszcza tylko litery, cyfry, „-”, „_” i „.”, maksymalnie 60 znaków, bez spacji.',
      statusTransition: 'Umowa nie może przejść ze stanu „{from}” do „{to}”.',
      reportingCycle: 'To przypisanie zamknęłoby linię podległości w pętlę.',
      ambiguousOrgCode: 'Kilka jednostek org. różnego rodzaju ma kod „{value}”. Proszę wskazać właściwą przez zewnętrzny identyfikator.',
      keys: {
        externalId: 'zewnętrzny identyfikator',
        employeeNumber: 'numer pracownika',
        code: 'kod',
      },
    },
    list: {
      title: 'Poprzednie importy',
      file: 'Plik',
      system: 'System źródłowy',
      status: 'Status',
      created: 'Utworzono',
      empty: 'Brak importów.',
      open: 'Otwórz',
      delete: 'Usuń',
      deleteConfirmTitle: 'Usunąć import?',
      deleteConfirmBody: '„{file}” i wszystkie powiązane pliki importu zostaną usunięte. Już przejęte dane pozostaną.',
      deleted: 'Import „{file}” został usunięty.',
    },
  },
  dataExport: {
    title: 'Eksport HR Open',
    intro: 'Eksportuje dane tego modułu jako HR Open 4.5 (HR-JSON) — zwalidowane względem standardu.',
    create: 'Utwórz eksport',
    creating: 'Tworzenie …',
    download: 'Pobierz',
    password: {
      title: 'Hasło ZIP — widoczne tylko teraz',
      hint: 'Eksport jest tworzony jako ZIP chroniony hasłem (AES-256), ponieważ zawiera dane osobowe. Skopiuj hasło teraz — nie zostanie ponownie wyświetlone. Otwórz np. 7-Zip, WinZip lub Keka.',
      copy: 'Skopiuj hasło',
      copied: 'Skopiowano',
    },
    empty: 'Brak eksportów.',
    columns: {
      standard: 'Standard',
      status: 'Status',
      items: 'Rekordy',
      created: 'Utworzono',
    },
    status: {
      queued: 'W kolejce',
      generating: 'Generowanie',
      completed: 'Zakończono',
      failed: 'Niepowodzenie',
    },
  },
  // The demo's module picker (ADR 0083): the fork offers it on entry, the bar's
  // reset confirmation again. A locked module is booked (or core) and always in.
  // RoleNameTranslations.vue (ADR 0086): a custom role's names in other
  // languages, or the notice a system role gets instead.
  roleNames: {
    translations: 'Tłumaczenia',
    translationsHint: 'Nazwa w innych językach. Puste pola pokazują nazwę powyżej.',
    systemHint: 'Rola systemowa: lumi nazywa ją w każdym języku. Jej nazwy i opisu nie można zmienić, uprawnienia tak.',
  },
  demoModules: {
    legend: 'Moduły w demo',
    booked: 'Wykupiony — zawsze uwzględniony',
  },
  demoStage: {
    label: 'Demo',
    viewingAs: 'Widok jako',
    personaPlaceholder: 'Wybierz rolę',
    persona: {
      team_lead: 'Kierownik zespołu',
      employee: 'Pracownik',
      hr_admin: 'Administrator HR',
      recruiter: 'Rekruter',
      ats_admin: 'Administrator ATS',
      council_member: 'Członek rady pracowników',
      apprentice: 'Uczeń zawodu',
      trainer: 'Opiekun praktyk',
    },
    personaDoes: {
      team_lead: 'Podejmuje decyzje w sprawie wniosków o nieobecność i korektę oraz ocenia aplikacje.',
      employee: 'Rejestruje dni pracy, składa wnioski o nieobecność i zleca korekty wpisów.',
      hr_admin: 'Tworzy osoby, projekty i oferty pracy.',
      recruiter: 'Przeprowadza aplikacje przez wstępną selekcję i planuje rozmowy kwalifikacyjne.',
      ats_admin: 'Podejmuje decyzje w sprawie nieobecności, ocenia aplikacje i tworzy oferty pracy.',
      council_member: 'Oddaje głos rady pracowników w sprawie ofert pracy i propozycji.',
      apprentice: 'Odhacza etapy planu nauki zawodu i rejestruje dni pracy.',
      trainer: 'Sprawdza raporty uczniów zawodu i planuje ich egzaminy.',
    },
    picker: {
      title: 'Z czyjej perspektywy ma być widoczne demo?',
      subtitle: '{count} współpracowników w {company}. Każda rola ma własne zadania — zaznaczenia są zapisywane osobno dla każdej roli.',
      taskCount: 'Zadania: {total}',
    },
    intro: {
      lead: 'jest fikcyjna. Osoby w tej firmie również są fikcyjne. Wszystko poniżej paska należy do demo — w jego ramach przyjmowane są różne role. Prawdziwe konto pozostaje nietknięte.',
      bridgeBefore: 'Demo można w każdej chwili zakończyć. Wszystkie dane poniżej zostaną wtedy usunięte i będzie można skonfigurować ',
      bridgeAfter: ' dla własnej organizacji.',
      close: 'Zamknij',
    },
    reset: 'Zresetuj demo',
    guestMarker: 'Gość',
    guestWelcome: {
      invitedBy: 'Współpracownik z {workspace} zaprosił Pana/Panią do tego demo.',
      invitedAnon: 'Współpracownik zaprosił Pana/Panią do tego demo.',
      body: '{company} jest fikcyjna i wspólna dla wszystkich osób w tym demo. Inni mogli już coś wypróbować, więc całość może wyglądać na częściowo wykorzystaną. „{reset}” daje wszystkim świeży start. Dostęp Pana/Pani wygaśnie wraz z końcem demo. Osoby w tej firmie również są fikcyjne.',
    },
    cancel: 'Anuluj',
    rebuildFailed: 'Nie udało się odbudować demo. Proszę spróbować ponownie.',
    resetConfirm: {
      title: 'Zresetować demo?',
      body: 'Wszystko, co {company} obecnie zawiera, zostanie usunięte — także to, co Pan/Pani lub współpracownicy wprowadzili, oraz postępy wszystkich na ścieżkach — a demo zostanie zbudowane od nowa. Wszyscy w demo zaczynają od nowa; dostępy się nie zmieniają.',
      cta: 'Zresetuj demo',
    },
    // The demo bar's "Invite a colleague" dialog (issue 669).
    guests: {
      entry: 'Zaproś współpracownika',
      title: 'Zaproś współpracownika',
      subtitle: 'Zaproszeni współpracownicy widzą to demo takie, jakie jest, i mogą samodzielnie je wypróbować.',
      close: 'Zamknij',
      loading: 'Ładowanie…',
      retry: 'Spróbuj ponownie',
      emailLabel: 'Służbowy adres e-mail',
      emailPlaceholder: "imie{'@'}firma.pl",
      send: 'Wyślij zaproszenie',
      sendAgain: 'Wyślij ponownie',
      slotsLeft: 'Wolne miejsca: {count}',
      exhausted: 'Wszystkie {limit} miejsca są zajęte. Proszę cofnąć poniżej jedno zaproszenie, aby zaprosić kogoś innego.',
      invalid: 'Proszę podać prawidłowy adres e-mail.',
      listTitle: 'W tym demo oprócz Pana/Pani',
      used: 'Zajęte: {used} z {limit}',
      empty: 'Nikt nie został jeszcze zaproszony.',
      state: {
        invited: 'Zaproszony',
        joined: 'Dołączył',
      },
      revoke: 'Cofnij',
      revoking: 'Cofanie…',
      revokeFor: 'Cofnij dostęp dla {email}',
      about: {
        title: 'Kim jest gość',
        sees: 'Gość widzi to demo dokładnie takie, jakie jest teraz — także wszystko, co Pan/Pani już wypróbował(a). „{reset}” w pasku daje wszystkim świeży start.',
        resets: 'Gość również może zresetować demo — dla wszystkich jego uczestników.',
        limits: 'Gość nigdy nie może zakończyć demo ani ingerować w Państwa prawdziwą przestrzeń roboczą.',
        ends: 'Goście są usuwani, gdy demo się kończy.',
      },
      feedback: {
        sent: 'Zaproszenie wysłano na adres {email}.',
        resent: 'Zaproszenie wysłano ponownie na adres {email}.',
        undelivered: 'Nie udało się dostarczyć wiadomości na adres {email}. Adres {email} jest na liście i zajmuje miejsce — proszę wysłać zaproszenie ponownie, aby spróbować jeszcze raz.',
        revoked: 'Dostęp dla {email} został cofnięty. Miejsce jest znowu wolne.',
        alreadyMember: '{email} ma już dostęp do tego obszaru roboczego.',
        limit: 'Wszystkie miejsca są zajęte. Proszę cofnąć jedno zaproszenie, aby zaprosić kogoś innego.',
        rateLimited: 'Dziś wysłano zbyt wiele zaproszeń. Proszę spróbować ponownie później.',
        notLive: 'Zaproszenia działają tylko, gdy demo jest aktywne. Demo jest właśnie odbudowywane albo rozpoczęto konfigurację — proszę spróbować ponownie, gdy demo wróci.',
        operator: 'Jest Pan/Pani zalogowany/a jako operator systemu. Operatorzy nie mogą zapraszać współpracowników do demo klienta.',
        operatorNotMember: '{email} należy do konta operatora lumi, które nie może dołączyć do demo klienta. Proszę zaprosić inny adres.',
        notAPerson: '{email} należy do konta, które nie jest osobą, na przykład konta usługowego. Proszę zaprosić służbowy adres e-mail współpracownika.',
        forbidden: 'Współpracowników mogą zapraszać tylko właściciel obszaru roboczego lub administrator suite.',
        noticeIncomplete: 'Zaproszenia są wstrzymane, dopóki informacje dla pracowników w sekcji Informacje prawne nie zostaną w pełni uzupełnione.',
        accountClosed: 'To konto zostało zamknięte i nie można go zaprosić.',
        unavailable: 'Zaproszeń nie można teraz policzyć. Proszę spróbować ponownie za chwilę.',
        revokeFailed: 'Nie udało się cofnąć dostępu dla {email}. Proszę spróbować ponownie.',
        generic: 'Coś poszło nie tak. Proszę spróbować ponownie.',
      },
    },
    leave: 'Zakończ demo',
    continueSetup: 'Kontynuuj konfigurację',
    menu: 'Działania demo',
    signOut: 'Wyloguj się',
    logoutHint: 'W trakcie demo można się wylogować przez drzwi lub menu na pasku demo.',
    journey: {
      title: 'Ścieżka: {name}',
      count: '{done} z {total} wykonano',
      refresh: 'Odśwież ścieżkę',
      unknown: 'Część sprawdzeń była niedostępna – wyświetlany jest ostatni znany stan.',
      yay: 'To była cała ścieżka: {name} – dobra robota.',
      bridgeAdmin: 'Wszystkie ścieżki zostały przejrzane. Kiedy będzie to wygodne, można zakończyć wersję demo i skonfigurować własną przestrzeń roboczą.',
      bridgeUser: 'Wszystkie ścieżki zostały przejrzane. Administrator może zakończyć wersję demo i skonfigurować Państwa przestrzeń roboczą.',
      blockedReset: 'Reset przywróci ten element:',
      blocked: {
        gone: 'Element potrzebny do tego zadania już nie istnieje.',
      },
      next: 'Następne',
      nextCta: 'Otwórz w {module}',
      footer: 'Demo odhacza to, co zostało zrobione.',
    },
  },
  // The shared notifications popover (NotificationsPopover.vue). Its own namespace: the
  // apps' `notifications.*` keys (inbox page, preferences) are theirs and stay put.
  notificationsPopover: {
    title: 'Powiadomienia',
    empty: 'Wszystko na bieżąco.',
    markAllRead: 'Oznacz wszystkie jako przeczytane',
    markRead: 'Oznacz jako przeczytane',
    markUnread: 'Oznacz jako nieprzeczytane',
    loading: 'Ładowanie…',
    openTarget: 'Otwórz powiązany element',
    goToAll: 'Przejdź do powiadomień',
  },
  // The shared place search (PlacePicker.vue). `noMatchAdd` is the wording for hosts whose
  // typed text IS the name (Enter adds it as typed); `noMatch` for hosts that keep it beside the field.
  placePicker: {
    placeholder: 'Proszę wyszukać miasto lub gminę …',
    keptHint: 'Zapisujemy dokładnie wpisany tekst — bez powiązanej miejscowości.',
    searching: 'Trwa wyszukiwanie …',
    typeMore: 'Proszę wpisać co najmniej {count} znaki',
    noMatch: 'Brak dopasowania — wpisany tekst pozostaje',
    error: 'Wyszukiwanie nie powiodło się',
    rateLimited: 'Zbyt wiele zapytań — ponowimy próbę za chwilę',
    resultsAnnouncement: 'Brak wyników | 1 wynik | Wyników: {count}',
    clear: 'Usuń miejscowość',
    noMatchAdd: 'Nie znaleziono miejscowości — Enter doda wpisaną nazwę',
  },
  // The suite's five app names and their one-line launcher descriptions, in this
  // language. THE one copy: component-lib's registry carries no displayed string, and
  // every app merges this underneath its own messages (ADR 0026 section 7).
  lumiModules: {
    suite: {
      name: 'Start',
      description: 'Przegląd miejsca pracy',
    },
    ats: {
      name: 'Rekrutacja',
      description: 'Stanowiska, aplikacje i proces rekrutacji',
    },
    time: {
      name: 'Czas',
      description: 'Rejestracja czasu pracy, konta czasu pracy i akceptacje',
    },
    people: {
      name: 'Kadry',
      description: 'Akta osobowe, działy i lokalizacje',
    },
    apprentice: {
      name: 'Praktykanci',
      description: 'Cyfrowe dzienniczki praktyk i plany kształcenia',
    },
  },
};
